export default "__VITE_ASSET__8fa22a33__"